// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyD4yWy7jZ7Dfz8ptHupIldWXfbMWm1sVOE",
  authDomain: "talk-ordercircle.firebaseapp.com",
  databaseURL: "https://talk-ordercircle-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "talk-ordercircle",
  storageBucket: "talk-ordercircle.firebasestorage.app",
  messagingSenderId: "96369629274",
  appId: "1:96369629274:web:b1d77b9f70518caf35e063",
  measurementId: "G-4D7S66RG9F"
};
